import countries from './countries.json'

export default {
	functional: true,
	props: {
		value: {},
		abbrev: {
			type: Boolean,
			default: true
		}
	},
	render (h, ctx) {
		const valueProp = (ctx.props.abbrev) ? 'abbreviation' : 'name'
		ctx.data.on = {
			input (e) {
				ctx.listeners.input(e.target.value)
			}
		}
		return (
			<select {...ctx.data}>
				<option value="">Select a country</option>
				{countries.map((country, idx) => {
					const value = country[valueProp]
					return (
						<option value={value} key={idx} selected={value === ctx.props.value}>{country.name}</option>
					)
				})}
			</select>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CountriesSelect/index.js